var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Typography, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { LocationByWarehouseList, ProductList } from "../../../api/url";
import { generateCodeName } from "../../../builderPackage/common/commonFunctions";
import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { MuiPopup } from "../../../components";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { labourListWPOGet, locationByWarehouseListGet, productListGet, WorkPurchaseOrderByJobcardNoAPI } from "../apiCall";
import { MultiSelectPopUp } from "./multiSelectPopUp";
export default function MultipleJCWPOPartDetails(props) {
    var _this = this;
    var _props$value, _getLocalStorageItem, _getLocalStorageItem2, _value$WPODetails;
    var onChange = props.onChange, value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? "WPODetails" : _a;
    var warehouseId = props === null || props === void 0 || (_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.SourceWarehouseId;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var _b = useState(), modalProps = _b[0], setModalProps = _b[1];
    useEffect(function () {
        productListGet({
            key: "ProductListData",
            url: ProductList
        });
    }, []);
    useEffect(function () {
        if (warehouseId) {
            locationByWarehouseListGet({
                key: "warehouseListData",
                request: {
                    WarehouseId: warehouseId
                },
                url: LocationByWarehouseList
            });
        }
    }, [warehouseId]);
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var UserParentOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var jobCardListAPI = function (params) { return WorkPurchaseOrderByJobcardNoAPI(_objectSpread(_objectSpread({}, params), {}, {
        request: _objectSpread(_objectSpread({}, params.request), {}, {
            OrganizationId: UserOrganization,
            ParentOrganizationId: UserParentOrganization
        }, params.request)
    })); };
    var columns = [{
            field: "JobCardNo",
            type: "searchSelect",
            headerName: "Job card",
            editable: true,
            flex: 1,
            headerAlign: "left",
            minWidth: 250,
            getListData: jobCardListAPI,
            getOptionLabel: function (option) { return option === null || option === void 0 ? void 0 : option.JobCardNo; },
            valueSetter: function (value, row) { return _objectSpread(_objectSpread({}, row), {}, {
                JobCardId: value === null || value === void 0 ? void 0 : value.JobCardId,
                JobCardNo: value === null || value === void 0 ? void 0 : value.JobCardNo,
                VIN: value === null || value === void 0 ? void 0 : value.VIN,
                OdometerReading: value === null || value === void 0 ? void 0 : value.OdometerReading,
                TechnicianId: value === null || value === void 0 ? void 0 : value.TechnicianId,
                TechnicianName: value === null || value === void 0 ? void 0 : value.TechnicianName
            }); },
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.JobCardNo; },
            renderCell: function (params) {
                var _params$row, _params$row2;
                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "h5",
                    style: {
                        fontSize: '12px',
                        fontWeight: 400,
                        color: '#1B1D21'
                    }
                }, params !== null && params !== void 0 && (_params$row = params.row) !== null && _params$row !== void 0 && _params$row.JobCardNo ? "".concat(params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.JobCardNo) : ""));
            }
        }, {
            type: 'searchSelect',
            field: 'Service',
            headerName: 'Service Name',
            editable: true,
            flex: 1,
            headerAlign: 'left',
            getListData: labourListWPOGet,
            getOptionLabel: function (value) { return generateCodeName(value, 'Code', 'Name'); },
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.Name; },
            valueSetter: function (value, row) { return _objectSpread(_objectSpread({}, row), {}, {
                Service: value,
                ServiceId: value === null || value === void 0 ? void 0 : value.id,
                ServiceName: value === null || value === void 0 ? void 0 : value.Name,
                ServiceCode: value === null || value === void 0 ? void 0 : value.Code,
                UOMName: value === null || value === void 0 ? void 0 : value.UOMName,
                UnitOfMeasurementId: value === null || value === void 0 ? void 0 : value.UnitOfMeasurementId,
                EntityId: value === null || value === void 0 ? void 0 : value.id,
                ChildId: value === null || value === void 0 ? void 0 : value.id
            }); },
            placeholder: 'Enter Part,Code',
            moreButtonText: 'Search More...',
            minWidth: 200,
            renderCell: function (params) {
                var _params$row3, _params$row4, _params$row5;
                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "h5",
                    style: {
                        fontSize: '12px',
                        fontWeight: 400,
                        color: '#1B1D21'
                    }
                }, (params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.ServiceName) || ""), /*#__PURE__*/ React.createElement(Typography, {
                    style: {
                        fontSize: '12px',
                        fontWeight: 400,
                        color: '#6A7682'
                    }
                }, params !== null && params !== void 0 && (_params$row4 = params.row) !== null && _params$row4 !== void 0 && _params$row4.ServiceCode ? "#".concat(params === null || params === void 0 || (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.ServiceCode) : ""));
            }
        }, {
            field: "UOMName",
            headerName: "UOM",
            editable: false,
            flex: 1,
            headerAlign: "center"
        }, {
            type: "number",
            field: "OdometerReading",
            headerName: "Odometer reading",
            editable: false,
            flex: 1,
            headerAlign: "center"
        }, {
            type: "number",
            field: "Rate",
            headerName: "Rate (₹)",
            editable: false,
            flex: 1,
            headerAlign: "center"
        }, {
            type: "number",
            field: "RequestedQuantity",
            headerName: "Quantity",
            editable: true,
            flex: 1,
            headerAlign: "center"
        }, {
            type: "number",
            field: "Taxes",
            headerName: "Taxes (%)",
            editable: true,
            flex: 1,
            headerAlign: "center"
        }, {
            type: "number",
            field: "TaxesAmount",
            headerName: "Tax Amt. (₹)",
            editable: true,
            flex: 1,
            headerAlign: "center"
        }, {
            type: "number",
            field: "DiscountPercentage",
            headerName: "Discount (%)",
            editable: true,
            flex: 1,
            headerAlign: "center"
        }, {
            type: "number",
            field: "DiscountAmount",
            headerName: "Discount (₹)",
            editable: true,
            flex: 1,
            headerAlign: "center"
        }, {
            type: "number",
            field: "TotalAmount",
            headerName: "Total Amount",
            editable: false,
            flex: 1,
            headerAlign: "center"
        }, {
            field: "Remarks",
            headerName: "Remarks",
            editable: true,
            flex: 1,
            headerAlign: "center"
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        onChange: onChange,
        disableAddRow: false,
        dataGridHeader: "Work order details",
        dataGridProps: {
            rowSelection: true,
            checkboxSelection: true,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            initialState: {
                pinnedColumns: {
                    left: ["__check__", "Product"],
                    right: ["Remarks"]
                }
            },
            processRowUpdate: function (newRow, oldRow) { return __awaiter(_this, void 0, void 0, function () {
                var row;
                return __generator(this, function (_a) {
                    row = newRow;
                    if ((newRow === null || newRow === void 0 ? void 0 : newRow.ServiceId) !== (oldRow === null || oldRow === void 0 ? void 0 : oldRow.ServiceId)) {
                        row = _objectSpread(_objectSpread({}, newRow), {}, {
                            JobCardId: value.JobCardId,
                            JobCardNo: value.JobCardNo,
                            VIN: value.VIN,
                            OdometerReading: value.OdometerReading,
                            TechnicianId: value.TechnicianId,
                            TechnicianName: value.TechnicianName
                        });
                    }
                    return [2 /*return*/, row];
                });
            }); }
        },
        rows: (_value$WPODetails = value.WPODetails) !== null && _value$WPODetails !== void 0 ? _value$WPODetails : [{
                id: 1
            }],
        validationModel: {},
        error: error === null || error === void 0 ? void 0 : error["WPIWorkOrderDetails"]
    }), /*#__PURE__*/ React.createElement(MuiPopup, {
        id: "part-location-popup",
        variant: "h1",
        openPopup: Boolean(modalProps),
        onClose: function () {
            setModalProps(undefined);
        },
        closeIcon: true,
        title: modalProps === null || modalProps === void 0 ? void 0 : modalProps.title,
        subTitleStyle: {
            marginTop: "10px",
            color: "#8593A3"
        },
        backdropEnable: true,
        padding: "15px 0px 0px 15px",
        containerStyle: {
            width: lgMode ? "500px" : "calc(90vw)",
            paddingTop: 0,
            paddingX: "16px"
        }
    }, modalProps && /*#__PURE__*/ React.createElement(MultiSelectPopUp, _extends({}, modalProps, {
        onClose: function () { return setModalProps(undefined); }
    }))));
}
